import React, { useState } from 'react';
import { Phone, X } from 'lucide-react';
import ContactForm from '../forms/ContactForm';

const CallbackButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Callback button */}
      <button
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-accent-500 text-white shadow-lg flex items-center justify-center hover:bg-accent-600 focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 transition-all duration-300"
        onClick={handleToggle}
      >
        {isOpen ? (
          <X className="h-6 w-6 animate-pulse" />
        ) : (
          <Phone className="h-6 w-6 animate-pulse" />
        )}
      </button>

      {/* Callback form */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-40 w-full max-w-sm bg-white rounded-lg shadow-xl p-6 border border-gray-200">
          <div className="mb-4">
            <h3 className="text-xl font-semibold text-gray-900">Заказать обратный звонок</h3>
            <p className="text-gray-600 text-sm mt-1">Оставьте контакты, и мы свяжемся с вами в ближайшее время</p>
          </div>
          <ContactForm buttonText="Заказать звонок" compact={true} onSuccess={() => setIsOpen(false)} />
        </div>
      )}
    </>
  );
};

export default CallbackButton;